// extracted by mini-css-extract-plugin
export default {"Dialog":"Dialog_Dialog__77znZ","Content":"Dialog_Content__ROGeq"};